import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";

import stepOneReducer from "./steps/stepOne/stepOne.slice";
import stepFiveReducer from "./steps/stepFive/stepFive.slice";
import selectionCategoriesReducer from "./steps/stepFive/selectionCategories/selectionCategories.slice";
import stepTwoReducer from "./steps/stepTwo/stepTwo.slice";
import directoriesReducer from "./directories/directories.slice";
import employeesReducer from "./employees/employees.slice";
import organizationsReducer from "./organizations/organizations.slice";
import profileReducer from "./profile/profile.slice";
import usersReducer from "./users/users.slice";
import objectsRegisterReducer from "./steps/stepTwo/objectsRegister/objectsRegister.slice";
import viewDocumentsReducer from "./steps/stepFive/viewDocuments/viewDocuments.slice";
import stepThreeReducer from "./steps/stepThree/stepThree.slice";
import stepSixReducer from "./steps/stepSix/stepSix.slice";
import stepSevenReducer from "./steps/stepSeven/stepSeven.slice";
import codesReducer from "./codes/codes.slice";
import foldersReducer from "./documents/folders/folders.slice";
import categorizationReducer from "./documents/categorization/categorization.slice";
import documentsReducer from "./documents/documents.slice";
import commentsSlice from "./comments/comments.slice";
import referencesReducer from "./references/references.slice";

export const store = configureStore({
	reducer: {
		stepOne: stepOneReducer,
		stepFive: stepFiveReducer,
		selectionCategories: selectionCategoriesReducer,
		stepTwo: stepTwoReducer,
		directories: directoriesReducer,
		employess: employeesReducer,
		organizations: organizationsReducer,
		profile: profileReducer,
		users: usersReducer,
		objectsRegister: objectsRegisterReducer,
		viewDocuments: viewDocumentsReducer,
		stepThree: stepThreeReducer,
		stepSix: stepSixReducer,
		stepSeven: stepSevenReducer,
		documents: documentsReducer,
		folders: foldersReducer,
		categorization: categorizationReducer,
		codes: codesReducer,
		references: referencesReducer,
		comments: commentsSlice,
	},
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
